import axios from "axios";

import { useAuthStore } from "../stores/authStore";
import type { RefreshTokenResponse } from "../types/auth";

interface ApiEnvelope<TData> {
  data: TData;
}

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? "/api";

let activeRefreshPromise: Promise<RefreshTokenResponse> | null = null;

export function refreshSessionTokens(refreshToken?: string | null): Promise<RefreshTokenResponse> {
  if (activeRefreshPromise) {
    return activeRefreshPromise;
  }

  const tokenToRefresh = refreshToken ?? useAuthStore.getState().refreshToken;
  if (!tokenToRefresh) {
    return Promise.reject(new Error("No refresh token available."));
  }

  activeRefreshPromise = axios
    .post<ApiEnvelope<RefreshTokenResponse>>(
      `${API_BASE_URL}/psc/auth/refresh/`,
      { refresh: tokenToRefresh },
      { timeout: 30000 },
    )
    .then((response) => {
      const tokens = response.data.data;
      useAuthStore.getState().updateTokens(tokens);
      return tokens;
    })
    .finally(() => {
      activeRefreshPromise = null;
    });

  return activeRefreshPromise;
}
